import React, { useState, useEffect } from 'react';

import { Dropdown, FormGroupRadio } from "components";

import { convertArrayToDropdownArrayFormat, func_validation, isArrayNotEmpty } from "functions";
import { Toaster } from 'components/notification/Toaster';

export function useProductInputs(props) {
    // Props

    let { 
        isEditing,

        advancePaySetup,
        
        isFormSubmissionAttempted,
    
        // productCodeList,
        productNameList,
        fullProductCodeList: productCodeList,
        getFullProductDetailList_errorMsg,

        // Functions
        getFullProductDetailList = () => {}
    } = props;

    let productCode_original = func_validation.getObjectPropertyValue(advancePaySetup, "ProductCode");
    let productName_original = func_validation.getObjectPropertyValue(advancePaySetup, "ProductName");

    // States
    const [productCode, setProductCode] = useState(productCode_original);
    const [productName, setProductName] = useState(productName_original);
    const [isAnyInputChanged, setIsAnyInputChanged] = useState(false);

    // Check for changes in input from initial
    useEffect(() => {
        let isNotChangedFromOriginal = (
            productCode === productCode_original &&
            productName === productName_original
        );

        let isChangedFromEmpty = (
            productCode || productName
        )

        setIsAnyInputChanged(isEditing? !isNotChangedFromOriginal: isChangedFromEmpty);   
    }, [
        productCode, productName
    ]);

    // Get full list
    useEffect(() => {
        getFullProductDetailList();
    }, []);

    let productCodeList_formatted = [];
    if (isArrayNotEmpty(productCodeList)) {
        productCodeList_formatted = productCodeList.map((obj) => {
            return {
                label: obj?.ProductCode,
                value: obj?.ProductCode
            }
        })
    }
    
    // Display
    let display = (
        <div className={"input-wrapper__product d-flex flex-wrap"}>
            {/* Product Code */}
            <Dropdown
                className={"product__product-code"}
                label={"Product Code"}
                isInputRequired

                selectedValueClassName={"product-code__input"}

                options={productCodeList_formatted}
                selectedValue_default={productCode}
                onChange={(value) => {
                    setProductCode(value);
                }}
                onBlur={(value) => {
                    if (isArrayNotEmpty(productCodeList)) {
                        let isMatchFound = false;
                        productCodeList.map((obj) => {
                            if (value === obj?.ProductCode) {
                                setProductName(obj?.ProductName);
                                isMatchFound = true;
                            }
                        });

                        if (!isMatchFound) {
                            setProductName("");

                            Toaster({
                                type: "info",
                                msg: "Product code must match option from the dropdown list",
                                timer: 10000
                            })
                        }
                    }
                }}

                errorMsg={"Required"}

                isFormSubmissionAttempted={isFormSubmissionAttempted}
                isSearchable
            />

            {/* Product Name */}
            <Dropdown
                className={"product__product-name"}
                label={"Product Name"}
                isInputRequired

                selectedValueClassName={"product-name__input"}

                // options={productNameList}
                selectedValue_default={productName}
                valueFromParent={productName}
                onChange={setProductName}

                errorMsg={"Required"}

                isFormSubmissionAttempted={isFormSubmissionAttempted}
                isSearchable 
                isDisabled={!getFullProductDetailList_errorMsg}
            />
        </div>
    );

    let isEveryInputValid = (
        func_validation.isStringTrimNotEmpty(productCode) &&
        func_validation.isStringTrimNotEmpty(productName)
    );

    let productDetails = {
        ProductCode: productCode,
        ProductName: productName,
    }

    return {
        productCode, 
        productName, 
        productDetails,

        isEveryInputValid,
        isAnyInputChanged,

        display
    }
}